module.exports = __webpack_public_path__ + "images/463242259d7bb6b91b7b7907f69b62a7roboticarm.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/roboticarm.png
// module id = DEQw
// module chunks = 0